// 單詞對照表
export const defaultDictionary = {
  "hello": { "zh": "你好", "emoji": "👋", "pos": "interjection" },
  "good": { "zh": "好的", "emoji": "👍", "pos": "adjective" },
  "morning": { "zh": "早晨", "emoji": "🌅", "pos": "noun" },
  "how": { "zh": "如何", "emoji": "❓", "pos": "adverb" },
  "are": { "zh": "是", "emoji": "✔️", "pos": "verb" },
  "you": { "zh": "你", "emoji": "👤", "pos": "pronoun" },
  "i": { "zh": "我", "emoji": "🙋", "pos": "pronoun" },
  "am": { "zh": "是", "emoji": "✔️", "pos": "verb" },
  "fine": { "zh": "好", "emoji": "😊", "pos": "adjective" },
  "thank": { "zh": "感謝", "emoji": "🙏", "pos": "verb" },
  "thanks": { "zh": "謝謝", "emoji": "🙏", "pos": "noun" },
  "nice": { "zh": "美好的", "emoji": "✨", "pos": "adjective" },
  "to": { "zh": "到", "emoji": "➡️", "pos": "preposition" },
  "meet": { "zh": "遇見", "emoji": "🤝", "pos": "verb" },
  "what": { "zh": "什麼", "emoji": "❓", "pos": "pronoun" },
  "your": { "zh": "你的", "emoji": "🧑", "pos": "pronoun" },
  "name": { "zh": "名字", "emoji": "📛", "pos": "noun" },
  "my": { "zh": "我的", "emoji": "🙋", "pos": "pronoun" },
  "where": { "zh": "哪裡", "emoji": "📍", "pos": "adverb" },
  "from": { "zh": "來自", "emoji": "🌍", "pos": "preposition" },
  "taiwan": { "zh": "台灣", "emoji": "🇹🇼", "pos": "noun" },
  "do": { "zh": "做", "emoji": "💼", "pos": "verb" },
  "work": { "zh": "工作", "emoji": "🏢", "pos": "noun" },
  "electrical": { "zh": "電子的", "emoji": "⚡", "pos": "adjective" },
  "engineer": { "zh": "工程師", "emoji": "👨‍💻", "pos": "noun" },
  "semiconductor": { "zh": "半導體", "emoji": "🔌", "pos": "noun" },
  "industry": { "zh": "產業", "emoji": "🏭", "pos": "noun" },
  "pretty": { "zh": "相當", "emoji": "😄", "pos": "adverb" },
  "long": { "zh": "長", "emoji": "📏", "pos": "adjective" },
  "time": { "zh": "時間", "emoji": "⏰", "pos": "noun" },
  "no": { "zh": "不", "emoji": "❌", "pos": "adverb" },
  "see": { "zh": "看", "emoji": "👀", "pos": "verb" },
  "great": { "zh": "偉大的", "emoji": "🎉", "pos": "adjective" },
  "again": { "zh": "再次", "emoji": "🔄", "pos": "adverb" },
  "have": { "zh": "有", "emoji": "✔️", "pos": "verb" },
  "day": { "zh": "一天", "emoji": "📅", "pos": "noun" },
  "once": { "zh": "從前", "emoji": "📖", "pos": "adverb" },
  "upon": { "zh": "在", "emoji": "📍", "pos": "preposition" },
  "there": { "zh": "那裡", "emoji": "🗺️", "pos": "adverb" },
  "were": { "zh": "有", "emoji": "✔️", "pos": "verb" },
  "three": { "zh": "三", "emoji": "3️⃣", "pos": "number" },
  "little": { "zh": "小的", "emoji": "🐷", "pos": "adjective" },
  "pigs": { "zh": "小豬", "emoji": "🐷", "pos": "noun" },
  "left": { "zh": "離開", "emoji": "👋", "pos": "verb" },
  "home": { "zh": "家", "emoji": "🏠", "pos": "noun" },
  "seek": { "zh": "尋找", "emoji": "🔍", "pos": "verb" },
  "fortune": { "zh": "運氣", "emoji": "🍀", "pos": "noun" },
  "first": { "zh": "第一", "emoji": "1️⃣", "pos": "adjective" },
  "built": { "zh": "建造", "emoji": "🔨", "pos": "verb" },
  "house": { "zh": "房子", "emoji": "🏠", "pos": "noun" },
  "straw": { "zh": "稻草", "emoji": "🌾", "pos": "noun" },
  "second": { "zh": "第二", "emoji": "2️⃣", "pos": "adjective" },
  "sticks": { "zh": "樹枝", "emoji": "🪵", "pos": "noun" },
  "third": { "zh": "第三", "emoji": "3️⃣", "pos": "adjective" },
  "bricks": { "zh": "磚塊", "emoji": "🧱", "pos": "noun" },
  "big": { "zh": "大的", "emoji": "🐘", "pos": "adjective" },
  "bad": { "zh": "壞的", "emoji": "😈", "pos": "adjective" },
  "wolf": { "zh": "狼", "emoji": "🐺", "pos": "noun" },
  "came": { "zh": "來", "emoji": "➡️", "pos": "verb" },
  "let": { "zh": "讓", "emoji": "👍", "pos": "verb" },
  "me": { "zh": "我", "emoji": "🙋", "pos": "pronoun" },
  "in": { "zh": "進入", "emoji": "🚪", "pos": "preposition" },
  "not": { "zh": "不", "emoji": "❌", "pos": "adverb" },
  "hair": { "zh": "毛", "emoji": "💇", "pos": "noun" },
  "huff": { "zh": "用力吹", "emoji": "💨", "pos": "verb" },
  "puff": { "zh": "吹", "emoji": "💨", "pos": "verb" },
  "blow": { "zh": "吹倒", "emoji": "💨", "pos": "verb" },
  "down": { "zh": "向下", "emoji": "⬇️", "pos": "preposition" },
  "ran": { "zh": "跑", "emoji": "🏃", "pos": "verb" },
  "both": { "zh": "兩者", "emoji": "2️⃣", "pos": "adjective" },
  "tried": { "zh": "嘗試", "emoji": "💪", "pos": "verb" },
  "could": { "zh": "能", "emoji": "✔️", "pos": "verb" },
  "clever": { "zh": "聰明的", "emoji": "🧠", "pos": "adjective" },
  "pot": { "zh": "鍋", "emoji": "🍲", "pos": "noun" },
  "hot": { "zh": "熱的", "emoji": "🔥", "pos": "adjective" },
  "water": { "zh": "水", "emoji": "💧", "pos": "noun" },
  "ready": { "zh": "準備好", "emoji": "✅", "pos": "adjective" },
  "away": { "zh": "離開", "emoji": "👋", "pos": "adverb" },
  "never": { "zh": "從不", "emoji": "❌", "pos": "adverb" },
  "back": { "zh": "回來", "emoji": "🔙", "pos": "adverb" },
  "happily": { "zh": "幸福地", "emoji": "😊", "pos": "adverb" },
  "ever": { "zh": "永遠", "emoji": "♾️", "pos": "adverb" },
  "after": { "zh": "之後", "emoji": "➡️", "pos": "preposition" }
};
